import $ from '../core/Dom';

export default el => {
    const info = $(el).find('[aria-live="polite"]');
    const slider = $(el).find('input[type="range"]');
    const field = $(el).find('input[type="hidden"]');

    // const max = Number.parseInt(slider.attr('max'), 10);

    let selectedValue = 0;

    const onUpdate = () => {
        // console.log(slider.val(), max);
        let currentValue = slider.val();
        console.log(currentValue);
        if (currentValue < 1.6) {
            currentValue = 1;
        }
        if (currentValue >= 1.6 && currentValue <= 2.5) {
            currentValue = 2;
        }
        if (currentValue > 2.5 && currentValue <= 3.2) {
            currentValue = 3;
        }
        if (currentValue > 3.2) {
            currentValue = 4;
        }

        if (currentValue !== selectedValue) {
            field.val(currentValue);
            selectedValue = currentValue;
            const selectedOption = $(slider.get(0).list).find(`option[value="${selectedValue}"]`);
            info.text(selectedOption.text());
        }
    };

    const init = () => {
        slider.on('input', onUpdate);
        onUpdate();
    };

    const destroy = () => {
        slider.off('input', onUpdate);
    };

    return {
        init,
        destroy
    };
};
